export default __webpack_public_path__ + "static/media/fireweapons.5ea00f88.png";